/**
 * ============================================================================================================================================================
 * 파일 업로드 다운로드 API 정의
 * ============================================================================================================================================================
 * 작성자 : 혁신기술팀 김성준
 * 작성일 : 2022-11-08
 * ============================================================================================================================================================
 */

import request from '@/utils/request'

/**
 * 멀티 파일 업로드
 * @param {*} params 
 * @param {*} isNotify 
 * @returns 
 */
export function multiUpload(params, isNotify) {
  var baseURL = `/api/file/multiUpload?desc=`
  return request({
    url: baseURL,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: params,
    Notify: { use: isNotify, apitype: 'save' }
  })
}

/**
 * 다운로드 파일
 * @param {*} params 
 * @returns 
 */
export function downloadFile(params) {
  var baseURL = `/api/file/downloadFile`
  return request({
    url: baseURL,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob',
    data: params
  })
}

/**
 * 다운로드 파일2
 * @param {*} params 
 * @returns 
 */
export function downloadServerFile(params) {
  return request({
    url: `/api/file/download?id=${params.id}&type=${params.type}`,
    meta: { apiVersion: '1.0.0' },
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  })
}

/**
 * 파일 목록
 * @param {*} isNotify 
 * @returns 
 */
export function getFileList(isNotify) {
  var baseURL = `/api/file/getFileList`
  return request({
    url: baseURL,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'search' }
  })
}

/**
 * 파일 삭제
 * @param {*} params 
 * @param {*} isNotify 
 * @returns 
 */
export function deleteFile(params, isNotify) {
  var baseURL = `/api/file/deleteFile`
  return request({
    url: baseURL,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { use: isNotify, apitype: 'delete' }
  })
}

/**
 * 파일 상세정보
 * @param {*} params 
 * @param {*} isNotify 
 * @returns 
 */
export function getFile(params, isNotify) {
  var baseURL = `/api/file/getFile`
  return request({
    url: baseURL,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { use: isNotify, apitype: 'search' }
  })
}